const CountryCodes = [
	{
		valueSecondary: '',
		icon: '',
		value: 'Clear',
		label: 'Clear',
	},
	{
		valueSecondary: '+44',
		icon: '🇬🇧',
		value: 'GB',
		label: 'United Kingdom',
	},
	{
		valueSecondary: '+376',
		icon: '🇦🇩',
		value: 'AD',
		label: 'Andorra',
	},
	{
		valueSecondary: '+971',
		icon: '🇦🇪',
		value: 'AE',
		label: 'United Arab Emirates',
	},
	{
		valueSecondary: '+93',
		icon: '🇦🇫',
		value: 'AF',
		label: 'Afghanistan',
	},
	{
		valueSecondary: '+1268',
		icon: '🇦🇬',
		value: 'AG',
		label: 'Antigua and Barbuda',
	},
	{
		valueSecondary: '+1264',
		icon: '🇦🇮',
		value: 'AI',
		label: 'Anguilla',
	},
	{
		valueSecondary: '+355',
		icon: '🇦🇱',
		value: 'AL',
		label: 'Albania',
	},
	{
		valueSecondary: '+374',
		icon: '🇦🇲',
		value: 'AM',
		label: 'Armenia',
	},
	/*	{
		"valueSecondary":"+599",
		"icon":"",
		"value":"AN",
		"label":"Netherlands Antilles"
	},*/
	{
		valueSecondary: '+244',
		icon: '🇦🇴',
		value: 'AO',
		label: 'Angola',
	},
	{
		valueSecondary: '+672',
		icon: '🇦🇶',
		value: 'AQ',
		label: 'Antarctica',
	},
	{
		valueSecondary: '+54',
		icon: '🇦🇷',
		value: 'AR',
		label: 'Argentina',
	},
	{
		valueSecondary: '+1684',
		icon: '🇦🇸',
		value: 'AS',
		label: 'American Samoa',
	},
	{
		valueSecondary: '+43',
		icon: '🇦🇹',
		value: 'AT',
		label: 'Austria',
	},
	{
		valueSecondary: '+61',
		icon: '🇦🇺',
		value: 'AU',
		label: 'Australia',
	},
	{
		valueSecondary: '+297',
		icon: '🇦🇼',
		value: 'AW',
		label: 'Aruba',
	},
	{
		valueSecondary: '+358',
		icon: '🇦🇽',
		value: 'AX',
		label: 'Åland Islands',
	},
	{
		valueSecondary: '+994',
		icon: '🇦🇿',
		value: 'AZ',
		label: 'Azerbaijan',
	},
	{
		valueSecondary: '+387',
		icon: '🇧🇦',
		value: 'BA',
		label: 'Bosnia and Herzegovina',
	},
	{
		valueSecondary: '+1246',
		icon: '🇧🇧',
		value: 'BB',
		label: 'Barbados',
	},
	{
		valueSecondary: '+880',
		icon: '🇧🇩',
		value: 'BD',
		label: 'Bangladesh',
	},
	{
		valueSecondary: '+32',
		icon: '🇧🇪',
		value: 'BE',
		label: 'Belgium',
	},
	{
		valueSecondary: '+226',
		icon: '🇧🇫',
		value: 'BF',
		label: 'Burkina Faso',
	},
	{
		valueSecondary: '+359',
		icon: '🇧🇬',
		value: 'BG',
		label: 'Bulgaria',
	},
	{
		valueSecondary: '+973',
		icon: '🇧🇭',
		value: 'BH',
		label: 'Bahrain',
	},
	{
		valueSecondary: '+257',
		icon: '🇧🇮',
		value: 'BI',
		label: 'Burundi',
	},
	{
		valueSecondary: '+229',
		icon: '🇧🇯',
		value: 'BJ',
		label: 'Benin',
	},
	{
		valueSecondary: '+590',
		icon: '🇧🇱',
		value: 'BL',
		label: 'Saint Barthelemy',
	},
	{
		valueSecondary: '+1441',
		icon: '🇧🇲',
		value: 'BM',
		label: 'Bermuda',
	},
	{
		valueSecondary: '+673',
		icon: '🇧🇳',
		value: 'BN',
		label: 'Brunei Darussalam',
	},
	{
		valueSecondary: '+591',
		icon: '🇧🇴',
		value: 'BO',
		label: 'Bolivia, Plurinational State of bolivia',
	},
	{
		valueSecondary: '+55',
		icon: '🇧🇷',
		value: 'BR',
		label: 'Brazil',
	},
	{
		valueSecondary: '+1242',
		icon: '🇧🇸',
		value: 'BS',
		label: 'Bahamas',
	},
	{
		valueSecondary: '+975',
		icon: '🇧🇹',
		value: 'BT',
		label: 'Bhutan',
	},
	{
		valueSecondary: '+47',
		icon: '🇧🇻',
		value: 'BV',
		label: 'Bouvet Island',
	},
	{
		valueSecondary: '+267',
		icon: '🇧🇼',
		value: 'BW',
		label: 'Botswana',
	},
	{
		valueSecondary: '+375',
		icon: '🇧🇾',
		value: 'BY',
		label: 'Belarus',
	},
	{
		valueSecondary: '+501',
		icon: '🇧🇿',
		value: 'BZ',
		label: 'Belize',
	},
	{
		valueSecondary: '+1',
		icon: '🇨🇦',
		value: 'CA',
		label: 'Canada',
	},
	{
		valueSecondary: '+61',
		icon: '🇨🇨',
		value: 'CC',
		label: 'Cocos (Keeling) Islands',
	},
	{
		valueSecondary: '+243',
		icon: '🇨🇩',
		value: 'CD',
		label: 'Congo, The Democratic Republic of the Congo',
	},
	{
		valueSecondary: '+236',
		icon: '🇨🇫',
		value: 'CF',
		label: 'Central African Republic',
	},
	{
		valueSecondary: '+242',
		icon: '🇨🇬',
		value: 'CG',
		label: 'Congo',
	},
	{
		valueSecondary: '+41',
		icon: '🇨🇭',
		value: 'CH',
		label: 'Switzerland',
	},
	{
		valueSecondary: '+225',
		icon: '🇨🇮',
		value: 'CI',
		label: "Cote d'Ivoire",
	},
	{
		valueSecondary: '+682',
		icon: '🇨🇰',
		value: 'CK',
		label: 'Cook Islands',
	},
	{
		valueSecondary: '+56',
		icon: '🇨🇱',
		value: 'CL',
		label: 'Chile',
	},
	{
		valueSecondary: '+237',
		icon: '🇨🇲',
		value: 'CM',
		label: 'Cameroon',
	},
	{
		valueSecondary: '+86',
		icon: '🇨🇳',
		value: 'CN',
		label: 'China',
	},
	{
		valueSecondary: '+57',
		icon: '🇨🇴',
		value: 'CO',
		label: 'Colombia',
	},
	{
		valueSecondary: '+506',
		icon: '🇨🇷',
		value: 'CR',
		label: 'Costa Rica',
	},
	{
		valueSecondary: '+53',
		icon: '🇨🇺',
		value: 'CU',
		label: 'Cuba',
	},
	{
		valueSecondary: '+238',
		icon: '🇨🇻',
		value: 'CV',
		label: 'Cape Verde',
	},
	{
		valueSecondary: '+61',
		icon: '🇨🇽',
		value: 'CX',
		label: 'Christmas Island',
	},
	{
		valueSecondary: '+357',
		icon: '🇨🇾',
		value: 'CY',
		label: 'Cyprus',
	},
	{
		valueSecondary: '+420',
		icon: '🇨🇿',
		value: 'CZ',
		label: 'Czech Republic',
	},
	{
		valueSecondary: '+49',
		icon: '🇩🇪',
		value: 'DE',
		label: 'Germany',
	},
	{
		valueSecondary: '+253',
		icon: '🇩🇯',
		value: 'DJ',
		label: 'Djibouti',
	},
	{
		valueSecondary: '+45',
		icon: '🇩🇰',
		value: 'DK',
		label: 'Denmark',
	},
	{
		valueSecondary: '+1767',
		icon: '🇩🇲',
		value: 'DM',
		label: 'Dominica',
	},
	{
		valueSecondary: '+1849',
		icon: '🇩🇴',
		value: 'DO',
		label: 'Dominican Republic',
	},
	{
		valueSecondary: '+213',
		icon: '🇩🇿',
		value: 'DZ',
		label: 'Algeria',
	},
	{
		valueSecondary: '+593',
		icon: '🇪🇨',
		value: 'EC',
		label: 'Ecuador',
	},
	{
		valueSecondary: '+372',
		icon: '🇪🇪',
		value: 'EE',
		label: 'Estonia',
	},
	{
		valueSecondary: '+20',
		icon: '🇪🇬',
		value: 'EG',
		label: 'Egypt',
	},
	{
		valueSecondary: '+291',
		icon: '🇪🇷',
		value: 'ER',
		label: 'Eritrea',
	},
	{
		valueSecondary: '+34',
		icon: '🇪🇸',
		value: 'ES',
		label: 'Spain',
	},
	{
		valueSecondary: '+251',
		icon: '🇪🇹',
		value: 'ET',
		label: 'Ethiopia',
	},
	{
		valueSecondary: '+358',
		icon: '🇫🇮',
		value: 'FI',
		label: 'Finland',
	},
	{
		valueSecondary: '+679',
		icon: '🇫🇯',
		value: 'FJ',
		label: 'Fiji',
	},
	{
		valueSecondary: '+500',
		icon: '🇫🇰',
		value: 'FK',
		label: 'Falkland Islands (Malvinas)',
	},
	{
		valueSecondary: '+691',
		icon: '🇫🇲',
		value: 'FM',
		label: 'Micronesia, Federated States of Micronesia',
	},
	{
		valueSecondary: '+298',
		icon: '🇫🇴',
		value: 'FO',
		label: 'Faroe Islands',
	},
	{
		valueSecondary: '+33',
		icon: '🇫🇷',
		value: 'FR',
		label: 'France',
	},
	{
		valueSecondary: '+241',
		icon: '🇬🇦',
		value: 'GA',
		label: 'Gabon',
	},
	{
		valueSecondary: '+1473',
		icon: '🇬🇩',
		value: 'GD',
		label: 'Grenada',
	},
	{
		valueSecondary: '+995',
		icon: '🇬🇪',
		value: 'GE',
		label: 'Georgia',
	},
	{
		valueSecondary: '+594',
		icon: '🇬🇫',
		value: 'GF',
		label: 'French Guiana',
	},
	{
		valueSecondary: '+44',
		icon: '🇬🇬',
		value: 'GG',
		label: 'Guernsey',
	},
	{
		valueSecondary: '+233',
		icon: '🇬🇭',
		value: 'GH',
		label: 'Ghana',
	},
	{
		valueSecondary: '+350',
		icon: '🇬🇮',
		value: 'GI',
		label: 'Gibraltar',
	},
	{
		valueSecondary: '+299',
		icon: '🇬🇱',
		value: 'GL',
		label: 'Greenland',
	},
	{
		valueSecondary: '+220',
		icon: '🇬🇲',
		value: 'GM',
		label: 'Gambia',
	},
	{
		valueSecondary: '+224',
		icon: '🇬🇳',
		value: 'GN',
		label: 'Guinea',
	},
	{
		valueSecondary: '+590',
		icon: '🇬🇵',
		value: 'GP',
		label: 'Guadeloupe',
	},
	{
		valueSecondary: '+240',
		icon: '🇬🇶',
		value: 'GQ',
		label: 'Equatorial Guinea',
	},
	{
		valueSecondary: '+30',
		icon: '🇬🇷',
		value: 'GR',
		label: 'Greece',
	},
	{
		valueSecondary: '+500',
		icon: '🇬🇸',
		value: 'GS',
		label: 'South Georgia and the South Sandwich Islands',
	},
	{
		valueSecondary: '+502',
		icon: '🇬🇹',
		value: 'GT',
		label: 'Guatemala',
	},
	{
		valueSecondary: '+1671',
		icon: '🇬🇺',
		value: 'GU',
		label: 'Guam',
	},
	{
		valueSecondary: '+245',
		icon: '🇬🇼',
		value: 'GW',
		label: 'Guinea-Bissau',
	},
	{
		valueSecondary: '+592',
		icon: '🇬🇾',
		value: 'GY',
		label: 'Guyana',
	},
	{
		valueSecondary: '+852',
		icon: '🇭🇰',
		value: 'HK',
		label: 'Hong Kong',
	},
	{
		valueSecondary: '+672',
		icon: '🇭🇲',
		value: 'HM',
		label: 'Heard Island and Mcdonald Islands',
	},
	{
		valueSecondary: '+504',
		icon: '🇭🇳',
		value: 'HN',
		label: 'Honduras',
	},
	{
		valueSecondary: '+385',
		icon: '🇭🇷',
		value: 'HR',
		label: 'Croatia',
	},
	{
		valueSecondary: '+509',
		icon: '🇭🇹',
		value: 'HT',
		label: 'Haiti',
	},
	{
		valueSecondary: '+36',
		icon: '🇭🇺',
		value: 'HU',
		label: 'Hungary',
	},
	{
		valueSecondary: '+62',
		icon: '🇮🇩',
		value: 'ID',
		label: 'Indonesia',
	},
	{
		valueSecondary: '+353',
		icon: '🇮🇪',
		value: 'IE',
		label: 'Ireland',
	},
	{
		valueSecondary: '+972',
		icon: '🇮🇱',
		value: 'IL',
		label: 'Israel',
	},
	{
		valueSecondary: '+44',
		icon: '🇮🇲',
		value: 'IM',
		label: 'Isle of Man',
	},
	{
		valueSecondary: '+91',
		icon: '🇮🇳',
		value: 'IN',
		label: 'India',
	},
	{
		valueSecondary: '+246',
		icon: '🇮🇴',
		value: 'IO',
		label: 'British Indian Ocean Territory',
	},
	{
		valueSecondary: '+964',
		icon: '🇮🇶',
		value: 'IQ',
		label: 'Iraq',
	},
	{
		valueSecondary: '+98',
		icon: '🇮🇷',
		value: 'IR',
		label: 'Iran, Islamic Republic of Persian Gulf',
	},
	{
		valueSecondary: '+354',
		icon: '🇮🇸',
		value: 'IS',
		label: 'Iceland',
	},
	{
		valueSecondary: '+39',
		icon: '🇮🇹',
		value: 'IT',
		label: 'Italy',
	},
	{
		valueSecondary: '+44',
		icon: '🇯🇪',
		value: 'JE',
		label: 'Jersey',
	},
	{
		valueSecondary: '+1876',
		icon: '🇯🇲',
		value: 'JM',
		label: 'Jamaica',
	},
	{
		valueSecondary: '+962',
		icon: '🇯🇴',
		value: 'JO',
		label: 'Jordan',
	},
	{
		valueSecondary: '+81',
		icon: '🇯🇵',
		value: 'JP',
		label: 'Japan',
	},
	{
		valueSecondary: '+254',
		icon: '🇰🇪',
		value: 'KE',
		label: 'Kenya',
	},
	{
		valueSecondary: '+996',
		icon: '🇰🇬',
		value: 'KG',
		label: 'Kyrgyzstan',
	},
	{
		valueSecondary: '+855',
		icon: '🇰🇭',
		value: 'KH',
		label: 'Cambodia',
	},
	{
		valueSecondary: '+686',
		icon: '🇰🇮',
		value: 'KI',
		label: 'Kiribati',
	},
	{
		valueSecondary: '+269',
		icon: '🇰🇲',
		value: 'KM',
		label: 'Comoros',
	},
	{
		valueSecondary: '+1869',
		icon: '🇰🇳',
		value: 'KN',
		label: 'Saint Kitts and Nevis',
	},
	{
		valueSecondary: '+850',
		icon: '🇰🇵',
		value: 'KP',
		label: "Korea, Democratic People's Republic of Korea",
	},
	{
		valueSecondary: '+82',
		icon: '🇰🇷',
		value: 'KR',
		label: 'Korea, Republic of South Korea',
	},
	{
		valueSecondary: '+965',
		icon: '🇰🇼',
		value: 'KW',
		label: 'Kuwait',
	},
	{
		valueSecondary: '+345',
		icon: '🇰🇾',
		value: 'KY',
		label: 'Cayman Islands',
	},
	{
		valueSecondary: '+7',
		icon: '🇰🇿',
		value: 'KZ',
		label: 'Kazakhstan',
	},
	{
		valueSecondary: '+856',
		icon: '🇱🇦',
		value: 'LA',
		label: 'Laos',
	},
	{
		valueSecondary: '+961',
		icon: '🇱🇧',
		value: 'LB',
		label: 'Lebanon',
	},
	{
		valueSecondary: '+1758',
		icon: '🇱🇨',
		value: 'LC',
		label: 'Saint Lucia',
	},
	{
		valueSecondary: '+423',
		icon: '🇱🇮',
		value: 'LI',
		label: 'Liechtenstein',
	},
	{
		valueSecondary: '+94',
		icon: '🇱🇰',
		value: 'LK',
		label: 'Sri Lanka',
	},
	{
		valueSecondary: '+231',
		icon: '🇱🇷',
		value: 'LR',
		label: 'Liberia',
	},
	{
		valueSecondary: '+266',
		icon: '🇱🇸',
		value: 'LS',
		label: 'Lesotho',
	},
	{
		valueSecondary: '+370',
		icon: '🇱🇹',
		value: 'LT',
		label: 'Lithuania',
	},
	{
		valueSecondary: '+352',
		icon: '🇱🇺',
		value: 'LU',
		label: 'Luxembourg',
	},
	{
		valueSecondary: '+371',
		icon: '🇱🇻',
		value: 'LV',
		label: 'Latvia',
	},
	{
		valueSecondary: '+218',
		icon: '🇱🇾',
		value: 'LY',
		label: 'Libyan Arab Jamahiriya',
	},
	{
		valueSecondary: '+212',
		icon: '🇲🇦',
		value: 'MA',
		label: 'Morocco',
	},
	{
		valueSecondary: '+377',
		icon: '🇲🇨',
		value: 'MC',
		label: 'Monaco',
	},
	{
		valueSecondary: '+373',
		icon: '🇲🇩',
		value: 'MD',
		label: 'Moldova',
	},
	{
		valueSecondary: '+382',
		icon: '🇲🇪',
		value: 'ME',
		label: 'Montenegro',
	},
	{
		valueSecondary: '+590',
		icon: '🇲🇫',
		value: 'MF',
		label: 'Saint Martin',
	},
	{
		valueSecondary: '+261',
		icon: '🇲🇬',
		value: 'MG',
		label: 'Madagascar',
	},
	{
		valueSecondary: '+692',
		icon: '🇲🇭',
		value: 'MH',
		label: 'Marshall Islands',
	},
	{
		valueSecondary: '+389',
		icon: '🇲🇰',
		value: 'MK',
		label: 'North Macedonia',
	},
	{
		valueSecondary: '+223',
		icon: '🇲🇱',
		value: 'ML',
		label: 'Mali',
	},
	{
		valueSecondary: '+95',
		icon: '🇲🇲',
		value: 'MM',
		label: 'Myanmar',
	},
	{
		valueSecondary: '+976',
		icon: '🇲🇳',
		value: 'MN',
		label: 'Mongolia',
	},
	{
		valueSecondary: '+853',
		icon: '🇲🇴',
		value: 'MO',
		label: 'Macao',
	},
	{
		valueSecondary: '+1670',
		icon: '🇲🇵',
		value: 'MP',
		label: 'Northern Mariana Islands',
	},
	{
		valueSecondary: '+596',
		icon: '🇲🇶',
		value: 'MQ',
		label: 'Martinique',
	},
	{
		valueSecondary: '+222',
		icon: '🇲🇷',
		value: 'MR',
		label: 'Mauritania',
	},
	{
		valueSecondary: '+1664',
		icon: '🇲🇸',
		value: 'MS',
		label: 'Montserrat',
	},
	{
		valueSecondary: '+356',
		icon: '🇲🇹',
		value: 'MT',
		label: 'Malta',
	},
	{
		valueSecondary: '+230',
		icon: '🇲🇺',
		value: 'MU',
		label: 'Mauritius',
	},
	{
		valueSecondary: '+960',
		icon: '🇲🇻',
		value: 'MV',
		label: 'Maldives',
	},
	{
		valueSecondary: '+265',
		icon: '🇲🇼',
		value: 'MW',
		label: 'Malawi',
	},
	{
		valueSecondary: '+52',
		icon: '🇲🇽',
		value: 'MX',
		label: 'Mexico',
	},
	{
		valueSecondary: '+60',
		icon: '🇲🇾',
		value: 'MY',
		label: 'Malaysia',
	},
	{
		valueSecondary: '+258',
		icon: '🇲🇿',
		value: 'MZ',
		label: 'Mozambique',
	},
	{
		valueSecondary: '+264',
		icon: '🇳🇦',
		value: 'NA',
		label: 'Namibia',
	},
	{
		valueSecondary: '+687',
		icon: '🇳🇨',
		value: 'NC',
		label: 'New Caledonia',
	},
	{
		valueSecondary: '+227',
		icon: '🇳🇪',
		value: 'NE',
		label: 'Niger',
	},
	{
		valueSecondary: '+672',
		icon: '🇳🇫',
		value: 'NF',
		label: 'Norfolk Island',
	},
	{
		valueSecondary: '+234',
		icon: '🇳🇬',
		value: 'NG',
		label: 'Nigeria',
	},
	{
		valueSecondary: '+505',
		icon: '🇳🇮',
		value: 'NI',
		label: 'Nicaragua',
	},
	{
		valueSecondary: '+31',
		icon: '🇳🇱',
		value: 'NL',
		label: 'Netherlands',
	},
	{
		valueSecondary: '+47',
		icon: '🇳🇴',
		value: 'NO',
		label: 'Norway',
	},
	{
		valueSecondary: '+977',
		icon: '🇳🇵',
		value: 'NP',
		label: 'Nepal',
	},
	{
		valueSecondary: '+674',
		icon: '🇳🇷',
		value: 'NR',
		label: 'Nauru',
	},
	{
		valueSecondary: '+683',
		icon: '🇳🇺',
		value: 'NU',
		label: 'Niue',
	},
	{
		valueSecondary: '+64',
		icon: '🇳🇿',
		value: 'NZ',
		label: 'New Zealand',
	},
	{
		valueSecondary: '+968',
		icon: '🇴🇲',
		value: 'OM',
		label: 'Oman',
	},
	{
		valueSecondary: '+507',
		icon: '🇵🇦',
		value: 'PA',
		label: 'Panama',
	},
	{
		valueSecondary: '+51',
		icon: '🇵🇪',
		value: 'PE',
		label: 'Peru',
	},
	{
		valueSecondary: '+689',
		icon: '🇵🇫',
		value: 'PF',
		label: 'French Polynesia',
	},
	{
		valueSecondary: '+675',
		icon: '🇵🇬',
		value: 'PG',
		label: 'Papua New Guinea',
	},
	{
		valueSecondary: '+63',
		icon: '🇵🇭',
		value: 'PH',
		label: 'Philippines',
	},
	{
		valueSecondary: '+92',
		icon: '🇵🇰',
		value: 'PK',
		label: 'Pakistan',
	},
	{
		valueSecondary: '+48',
		icon: '🇵🇱',
		value: 'PL',
		label: 'Poland',
	},
	{
		valueSecondary: '+508',
		icon: '🇵🇲',
		value: 'PM',
		label: 'Saint Pierre and Miquelon',
	},
	{
		valueSecondary: '+64',
		icon: '🇵🇳',
		value: 'PN',
		label: 'Pitcairn',
	},
	{
		valueSecondary: '+1939',
		icon: '🇵🇷',
		value: 'PR',
		label: 'Puerto Rico',
	},
	{
		valueSecondary: '+970',
		icon: '🇵🇸',
		value: 'PS',
		label: 'Palestinian Territory, Occupied',
	},
	{
		valueSecondary: '+351',
		icon: '🇵🇹',
		value: 'PT',
		label: 'Portugal',
	},
	{
		valueSecondary: '+680',
		icon: '🇵🇼',
		value: 'PW',
		label: 'Palau',
	},
	{
		valueSecondary: '+595',
		icon: '🇵🇾',
		value: 'PY',
		label: 'Paraguay',
	},
	{
		valueSecondary: '+974',
		icon: '🇶🇦',
		value: 'QA',
		label: 'Qatar',
	},
	{
		valueSecondary: '+262',
		icon: '🇷🇪',
		value: 'RE',
		label: 'Reunion',
	},
	{
		valueSecondary: '+40',
		icon: '🇷🇴',
		value: 'RO',
		label: 'Romania',
	},
	{
		valueSecondary: '+381',
		icon: '🇷🇸',
		value: 'RS',
		label: 'Serbia',
	},
	{
		valueSecondary: '+7',
		icon: '🇷🇺',
		value: 'RU',
		label: 'Russia',
	},
	{
		valueSecondary: '+250',
		icon: '🇷🇼',
		value: 'RW',
		label: 'Rwanda',
	},
	{
		valueSecondary: '+966',
		icon: '🇸🇦',
		value: 'SA',
		label: 'Saudi Arabia',
	},
	{
		valueSecondary: '+677',
		icon: '🇸🇧',
		value: 'SB',
		label: 'Solomon Islands',
	},
	{
		valueSecondary: '+248',
		icon: '🇸🇨',
		value: 'SC',
		label: 'Seychelles',
	},
	{
		valueSecondary: '+249',
		icon: '🇸🇩',
		value: 'SD',
		label: 'Sudan',
	},
	{
		valueSecondary: '+46',
		icon: '🇸🇪',
		value: 'SE',
		label: 'Sweden',
	},
	{
		valueSecondary: '+65',
		icon: '🇸🇬',
		value: 'SG',
		label: 'Singapore',
	},
	{
		valueSecondary: '+290',
		icon: '🇸🇭',
		value: 'SH',
		label: 'Saint Helena, Ascension and Tristan Da Cunha',
	},
	{
		valueSecondary: '+386',
		icon: '🇸🇮',
		value: 'SI',
		label: 'Slovenia',
	},
	{
		valueSecondary: '+47',
		icon: '🇸🇯',
		value: 'SJ',
		label: 'Svalbard and Jan Mayen',
	},
	{
		valueSecondary: '+421',
		icon: '🇸🇰',
		value: 'SK',
		label: 'Slovakia',
	},
	{
		valueSecondary: '+232',
		icon: '🇸🇱',
		value: 'SL',
		label: 'Sierra Leone',
	},
	{
		valueSecondary: '+378',
		icon: '🇸🇲',
		value: 'SM',
		label: 'San Marino',
	},
	{
		valueSecondary: '+221',
		icon: '🇸🇳',
		value: 'SN',
		label: 'Senegal',
	},
	{
		valueSecondary: '+252',
		icon: '🇸🇴',
		value: 'SO',
		label: 'Somalia',
	},
	{
		valueSecondary: '+597',
		icon: '🇸🇷',
		value: 'SR',
		label: 'Suriname',
	},
	{
		valueSecondary: '+211',
		icon: '🇸🇸',
		value: 'SS',
		label: 'South Sudan',
	},
	{
		valueSecondary: '+239',
		icon: '🇸🇹',
		value: 'ST',
		label: 'Sao Tome and Principe',
	},
	{
		valueSecondary: '+503',
		icon: '🇸🇻',
		value: 'SV',
		label: 'El Salvador',
	},
	{
		valueSecondary: '+963',
		icon: '🇸🇾',
		value: 'SY',
		label: 'Syrian Arab Republic',
	},
	{
		valueSecondary: '+268',
		icon: '🇸🇿',
		value: 'SZ',
		label: 'Swaziland',
	},
	{
		valueSecondary: '+1649',
		icon: '🇹🇨',
		value: 'TC',
		label: 'Turks and Caicos Islands',
	},
	{
		valueSecondary: '+235',
		icon: '🇹🇩',
		value: 'TD',
		label: 'Chad',
	},
	{
		valueSecondary: '+262',
		icon: '🇹🇫',
		value: 'TF',
		label: 'French Southern Territories',
	},
	{
		valueSecondary: '+228',
		icon: '🇹🇬',
		value: 'TG',
		label: 'Togo',
	},
	{
		valueSecondary: '+66',
		icon: '🇹🇭',
		value: 'TH',
		label: 'Thailand',
	},
	{
		valueSecondary: '+992',
		icon: '🇹🇯',
		value: 'TJ',
		label: 'Tajikistan',
	},
	{
		valueSecondary: '+690',
		icon: '🇹🇰',
		value: 'TK',
		label: 'Tokelau',
	},
	{
		valueSecondary: '+670',
		icon: '🇹🇱',
		value: 'TL',
		label: 'Timor-Leste',
	},
	{
		valueSecondary: '+993',
		icon: '🇹🇲',
		value: 'TM',
		label: 'Turkmenistan',
	},
	{
		valueSecondary: '+216',
		icon: '🇹🇳',
		value: 'TN',
		label: 'Tunisia',
	},
	{
		valueSecondary: '+676',
		icon: '🇹🇴',
		value: 'TO',
		label: 'Tonga',
	},
	{
		valueSecondary: '+90',
		icon: '🇹🇷',
		value: 'TR',
		label: 'Türkiye',
	},
	{
		valueSecondary: '+1868',
		icon: '🇹🇹',
		value: 'TT',
		label: 'Trinidad and Tobago',
	},
	{
		valueSecondary: '+688',
		icon: '🇹🇻',
		value: 'TV',
		label: 'Tuvalu',
	},
	{
		valueSecondary: '+886',
		icon: '🇹🇼',
		value: 'TW',
		label: 'Taiwan',
	},
	{
		valueSecondary: '+255',
		icon: '🇹🇿',
		value: 'TZ',
		label: 'Tanzania, United Republic of Tanzania',
	},
	{
		valueSecondary: '+380',
		icon: '🇺🇦',
		value: 'UA',
		label: 'Ukraine',
	},
	{
		valueSecondary: '+256',
		icon: '🇺🇬',
		value: 'UG',
		label: 'Uganda',
	},
	{
		valueSecondary: '+1',
		icon: '🇺🇸',
		value: 'US',
		label: 'United States',
	},
	{
		valueSecondary: '+598',
		icon: '🇺🇾',
		value: 'UY',
		label: 'Uruguay',
	},
	{
		valueSecondary: '+998',
		icon: '🇺🇿',
		value: 'UZ',
		label: 'Uzbekistan',
	},
	{
		valueSecondary: '+379',
		icon: '🇻🇦',
		value: 'VA',
		label: 'Holy See (Vatican City State)',
	},
	{
		valueSecondary: '+1784',
		icon: '🇻🇨',
		value: 'VC',
		label: 'Saint Vincent and the Grenadines',
	},
	{
		valueSecondary: '+58',
		icon: '🇻🇪',
		value: 'VE',
		label: 'Venezuela, Bolivarian Republic of Venezuela',
	},
	{
		valueSecondary: '+1284',
		icon: '🇻🇬',
		value: 'VG',
		label: 'Virgin Islands, British',
	},
	{
		valueSecondary: '+1340',
		icon: '🇻🇮',
		value: 'VI',
		label: 'Virgin Islands, U.S.',
	},
	{
		valueSecondary: '+84',
		icon: '🇻🇳',
		value: 'VN',
		label: 'Vietnam',
	},
	{
		valueSecondary: '+678',
		icon: '🇻🇺',
		value: 'VU',
		label: 'Vanuatu',
	},
	{
		valueSecondary: '+681',
		icon: '🇼🇫',
		value: 'WF',
		label: 'Wallis and Futuna',
	},
	{
		valueSecondary: '+685',
		icon: '🇼🇸',
		value: 'WS',
		label: 'Samoa',
	},
	{
		valueSecondary: '+383',
		icon: '🇽🇰',
		value: 'XK',
		label: 'Kosovo',
	},
	{
		valueSecondary: '+967',
		icon: '🇾🇪',
		value: 'YE',
		label: 'Yemen',
	},
	{
		valueSecondary: '+262',
		icon: '🇾🇹',
		value: 'YT',
		label: 'Mayotte',
	},
	{
		valueSecondary: '+27',
		icon: '🇿🇦',
		value: 'ZA',
		label: 'South Africa',
	},
	{
		valueSecondary: '+260',
		icon: '🇿🇲',
		value: 'ZM',
		label: 'Zambia',
	},
	{
		valueSecondary: '+263',
		icon: '🇿🇼',
		value: 'ZW',
		label: 'Zimbabwe',
	},
];

export { CountryCodes };
